import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DigitalSignatureRequestStatus, DomainTraditionReportType, OrderStatus, OrderType, Personality, ReimbursementOperation, CustomerType } from 'src/app/@core/constants';
import { PosIp800ModalService } from 'src/app/@core/services/pos-ip800-modal.service';
import { CalculationUtils } from 'src/app/@core/utils/calculation-utils';
import { DateUtils } from 'src/app/@core/utils/date-utils';
import { Advance } from 'src/app/models/advance';
import { Customer } from 'src/app/models/customer';
import { DigitalSignature, DigitalSignatureDocument, DigitalSignatureDocumentType } from 'src/app/models/digital-signature';
import { Invoice } from 'src/app/models/invoice';
import { Loan } from 'src/app/models/loan';
import { OrderCheckList } from 'src/app/models/order-checklist';
import { OrderCompleteProcess } from 'src/app/models/order-complete-process';
import { Recollection } from 'src/app/models/recollection';
import { Reimbursement } from 'src/app/models/reimbursement';
import { ContractReturnResponseCompleteModel } from 'src/app/models/response/contract-return-response-complete-model';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { InsuranceRejectionService } from 'src/app/services/insurance-rejection.service';
import { LoanService } from 'src/app/services/loan.service';
import { ParamsService } from 'src/app/services/params.service';
import { ProductsService } from 'src/app/services/products.service';
import { ReportService } from 'src/app/services/report.service';
import { DigitalSignatureRequestStatusInOrder, OrderConditions, PrintType } from './../../@core/constants';

@Component({
  selector: 'app-pos-print-documents-modal',
  templateUrl: './pos-print-documents-modal.component.html',
  styleUrls: ['./pos-print-documents-modal.component.sass']
})
export class PosPrintDocumentsModalComponent implements OnInit {

  public processedOrder: OrderCompleteProcess = new OrderCompleteProcess();

  // quotation: boolean = false;
  invoices: Array<{ code: string, fullNumber?: string, print: boolean, printType: PrintType }> = new Array<{ code: string, fullNumber?: string, print: boolean, printType: PrintType }>();
  originalInvoices: Array<{ code: string, fullNumber?: string, print: boolean, printType: PrintType }> = new Array<{ code: string, fullNumber?: string, print: boolean, printType: PrintType }>();
  receipts: Array<{ code: string, print: boolean }> = new Array<{ code: string, print: boolean }>();
  debitNote: Array<{ code: string, print: boolean }> = new Array<{ code: string, print: boolean }>();
  promissoryNotes: Array<{ code: string, print: boolean }> = [];
  vehicleRegistration: boolean = false;
  thirdPartyForm = { identity: "", name: "" };
  thirdPartyAuthoriztion = { code: "", print: false };
  checklist: Array<{ code: string, print: boolean, salesOrgCode: string, checklistCode: string }> = [];
  productDelivery = { code: "", print: false };
  productVerification = { code: "", print: false };
  releaseOfResponsibility = { code: "", print: false };
  purchaseOrder = { code: "", print: false };
  registrationRefusal = { code: "", location: "", print: false };
  insuranceRejection = { code: "", location: "", print: false };
  warrantyCertificate: Array<{ invoiceCode: string, invoiceNumber: string, print: boolean }> = [];
  ip800File: { code: string, customerCode: string, print: boolean } = { code: "", customerCode: "", print: false };
  domainTraditionFiles: Array<{ code: string, invoiceNumber: string, type: DomainTraditionReportType, print: boolean }> = [];
  circulationPermits: Array<{ code: string, print: boolean }> = [];
  digitalSignature: DigitalSignature = new DigitalSignature();
  paymentPlan: Array<{ code: string, print: boolean }> = [];
  loan: Array<{ code: string, print: boolean }> = [];
  loanCancellations: Array<{ code: string, contractNumber: string, print: boolean }> = [];
  quotations: Array<{ loanCode?: string, print: boolean }> = [];
  extraWarrantyCertificate: Array<{ invoiceCode: string, orderEntryListIndex?: number, print: boolean }> = [];
  settlement: { code: string, print: boolean } = { code: "", print: false };
  invoiceRequests: Array<{ code: string, fullNumber: string | undefined, print: boolean }> = [];
  vouchers: Array<{ code: string, print: boolean }> = new Array<{ code: string, print: boolean }>();
  refinancing: Array<{ code: string, print: boolean }> = [];
  UNTIL_30_DAYS_FRANCHISED = 1;
  MORE_THAN_30_DAYS_FRANCHISED = 2;

  customer: Customer = new Customer();
  loanObj: Loan = new Loan();
  orderChecklist: OrderCheckList = new OrderCheckList();
  isOnlyCreditsDocuments = false;
  customerStatus: string = "";

  creditNotes: Array<{ code: string, fullNumber?: string, salesOrg: string, print: boolean }> = [];
  returnReceipts: Array<{ code: string, print: boolean }> = new Array<{ code: string, print: boolean }>();
  receiptRollbacks: Array<{ code: string, fullNumber?: string, salesOrg: string, branchCode: string, sellerCode: string, receiptCode: string, print: boolean }> = [];

  // for print recollection's documents
  recollectionReceipts: Array<{ code: string, print: boolean }> = new Array<{ code: string, print: boolean }>();
  recollectionInvoices: Array<{ code: string, fullNumber?: string, print: boolean, printType: PrintType, salesOrg: string }> = new Array<{ code: string, fullNumber?: string, print: boolean, printType: PrintType, salesOrg: string }>();
  isForPrintRecollectionDocuments = false;
  recollection: Recollection | undefined;
  recollectionInvoicesObj: { fullNumber: string, netTotal: number, code: string, salesOrg: string } | undefined;

  // for print contractReturn's documents
  isForPrintContractReturnDocuments = false;
  contractReturnResponseComplete: ContractReturnResponseCompleteModel = new ContractReturnResponseCompleteModel();

  isForAdvanceDocuments: boolean = false;
  advance: Advance = new Advance();
  advanceDocument: { code: string, receiptCode: string, salesOrg: string, print: boolean } = { code: "", receiptCode: "", salesOrg: "", print: false };
  advanceReturnDocument: { code: string, receiptCode: string, salesOrg: string, print: boolean } = { code: "", receiptCode: "", salesOrg: "", print: false };

  isForReimbursement: boolean = false;
  reimbursement: Reimbursement = new Reimbursement();
  reimbursementDocument: { documentNumber: string, salesOrg: string, operation: ReimbursementOperation, print: boolean } = { documentNumber: "", operation: ReimbursementOperation.PAYMENT, print: false, salesOrg: "" };
  creditReference: { customerCode: string, toWhom: string, salesOrg: string, print: boolean } = { customerCode: "", toWhom: "", salesOrg: "", print: false };
  isForOrderChecklist = false;
  constructor(
    public bsModalRef: BsModalRef,
    private reportService: ReportService,
    private authService: AuthService,
    private loanService: LoanService,
    private readonly exceptionSolutionService: ExceptionSolutionService,
    private readonly insuranceRejectionService: InsuranceRejectionService,
    private readonly paramsService: ParamsService,
    private readonly ip800ModalService: PosIp800ModalService,
    private readonly configService: ConfigurationService,
    private readonly productService: ProductsService) { }

  ngOnInit(): void {

    if (this.isOnlyCreditsDocuments) {
      this.loadDigitalDocuments();
      this.loadOnlyCreditDocuments();
    }
    if (this.isForPrintRecollectionDocuments) {
      this.loadPrintRecollectionDocuments();
    }

    if (this.isForPrintContractReturnDocuments) {
      this.loadContractReturnDocuments();
    }
    if (this.isForAdvanceDocuments) {
      this.loadAdvanceDocuments();
    }
    if (this.isForReimbursement) {
      this.loadReimbursementDocuments();
    }

    if (this.isForOrderChecklist) {
      if (this.orderChecklist.salesOrgCode == "1400") {
        if (this.orderChecklist.status != OrderStatus.FINAL && this.orderChecklist.status != OrderStatus.VOIDED) {
          this.releaseOfResponsibility = { code: this.orderChecklist.code, print: true };
        }
      }
      else if (this.orderChecklist.status == OrderStatus.FINAL) {
        if (this.orderChecklist.isForEquipment) {
          this.checklist.push({ code: this.orderChecklist.invoiceCode, print: true, salesOrgCode: this.orderChecklist.salesOrgCode, checklistCode: this.orderChecklist.code });
        }
      }

    }
  }

  private loadReimbursementDocuments() {
    this.reimbursementDocument = { documentNumber: this.reimbursement.documentNumber, operation: this.reimbursement.operation, print: true, salesOrg: this.reimbursement.salesOrgCode };
  }

  private loadAdvanceDocuments() {
    this.advanceDocument = { code: this.advance.code, receiptCode: this.advance.receiptCode, salesOrg: this.advance.salesOrg, print: true };
    if (this.advance.returnAdvanceCode) {
      this.advanceReturnDocument = { code: this.advance.returnAdvanceCode, receiptCode: this.advance.receiptCode, salesOrg: this.advance.salesOrg, print: true };
    }
  }

  private loadContractReturnDocuments() {
    if (this.contractReturnResponseComplete.voucher) {
      const { voucherCode } = this.contractReturnResponseComplete.voucher;
      this.vouchers = [{ code: voucherCode, print: true }];
    }

    if (this.contractReturnResponseComplete.receipt != null) {
      const { code } = this.contractReturnResponseComplete.receipt;
      this.returnReceipts = [{ code, print: true }];
    }
  }

  private loadPrintRecollectionDocuments() {
    if (this.recollection?.recollectionType === 'REPAIRSHOP') {
      const { code, fullNumber, salesOrg } = this.recollectionInvoicesObj || new Invoice();
      this.recollectionInvoices = [{ code, fullNumber, print: true, printType: PrintType.ORIGINAL, salesOrg }, { code, fullNumber, print: true, printType: PrintType.COPY, salesOrg }];
    } else {
      this.recollectionReceipts = [{ code: this.recollection?.receipt.code || '', print: true }];
    }
  }

  private loadOnlyCreditDocuments() {
    if (this.loanObj.salesOrg != "1400") {
      this.loan = [{ code: this.loanObj.contractNumber, print: true }];
    }
    this.promissoryNotes = this.processedOrder.loans.map(loan => {
      return { code: loan.contractNumber, print: true };
    });
    this.paymentPlan = this.processedOrder.loans.map(loan => {
      return { code: loan.contractNumber, print: true };
    });
    this.debitNote = this.processedOrder.receipts.filter(f => f.debitNote).map(receipt => {
      return { code: receipt.code, print: true };
    });
    if (this.loanObj.voucher?.voucherCode) {
      this.vouchers = [{ code: this.loanObj.voucher.voucherCode, print: true }];
    }
    this.settlement = { code: this.loanObj.contractNumber, print: false };
     if (CustomerType.EMPLOYEE == this.customer.customerType) {
      this.refinancing = this.processedOrder.loans.map(l => ({ code: l.contractNumber, print: false }))
    }
  }

  loadInfo() {
    this.loadPurchaseOrderDocument();
    this.loadInvoiceDocuments()
    this.loadCreditDocuments();
    this.loadReceipts();
    this.loadEquipmentDocuments();
    this.loadWarrantyDocuments();
    this.loadVoucherDocuments();
    this.loadReturnDocuments();
    this.loadReturnReceipts();
    this.loadQuotationDocuments();
    this.loadDigitalDocuments();
    this.loadCreditReferenceDocument();
  }

  async loadCreditReferenceDocument() {
    const creditReferenceProductCode = (await this.paramsService.readParam("print-credit-reference-product").toPromise()).response.value ?? "";
    if (this.processedOrder.order.orderEntryList.some(s => s.productCode == creditReferenceProductCode)) {
      this.creditReference = { customerCode: this.processedOrder.order.customerCode, salesOrg: this.processedOrder.order.salesOrgCode, toWhom: "", print: true };
    }
  }


  private loadDigitalDocuments() {
    if (this.canShowDigitalSignatureDocs) {
      this.digitalSignature.documents.forEach(document => {
        document.print = true;
      });

      this.digitalSignature.documents.filter(document => document.documentType === DigitalSignatureDocumentType.INVOICE).forEach(invoice => {
        invoice.printType = this.digitalSignature.requestNumber ? PrintType.ORIGINAL : PrintType.COPY;
      });
    }
  }

  private loadReturnReceipts() {
    this.returnReceipts = this.processedOrder.returnReceipts.map(returnReceipt => {
      return { code: returnReceipt.code, print: true };
    });
  }

  private loadVoucherDocuments() {
    this.vouchers = this.processedOrder.vouchers.map(voucher => {
      return { code: voucher.voucherCode, print: true };
    });
  }

  private loadPurchaseOrderDocument() {
    this.purchaseOrder.code = this.processedOrder.order.code;
    this.purchaseOrder.print = false;
  }

  private async loadWarrantyDocuments() {

    const extraWarrantyProducts = (await this.productService.readProducts({ page: 0, pageSize: 100, value: { serviceTypes: "EXTRA_WARRANTY" } }).toPromise()).response;
    if (this.processedOrder.order.status == OrderStatus.FINAL) {
      for (const [index, orderEntry] of this.processedOrder.order.orderEntryList.filter(oe => extraWarrantyProducts.content.some(ep => oe.productCode == ep.code)).entries()) {
        const warrantyIndex = this.processedOrder.order.orderEntryList.findIndex(f => f.code == (orderEntry.extraWarrantyInvoiceCode ? orderEntry.code : orderEntry.associatedOrderEntry));
        const invoice = this.processedOrder.invoices.find(i => i.deliveryInvoiceLines.some(dil => dil.orderEntryCode == orderEntry.code));
        if (warrantyIndex >= 0) {
          this.extraWarrantyCertificate = [...this.extraWarrantyCertificate, { invoiceCode: invoice?.code || '', orderEntryListIndex: warrantyIndex, print: true }];
        }
      }
    }
  }

  private async loadEquipmentDocuments() {
    this.loadDomainTraditionDocuments();
    await this.loadVehicleRegistrationDocuments();
  }

  private async loadVehicleRegistrationDocuments() {
    let services = this.processedOrder.order.orderEntryList
      .filter(f => f.productCode === "PAGO_MATRICULA" || f.productCode === "PAGO_PLACA")
      .map(m => m.code);
    if (services.length > 0 && this.processedOrder.order.status == OrderStatus.FINAL && this.processedOrder.order.orderType != OrderType.RETURN) {
      this.vehicleRegistration = true;

      let productOnInvoice = this.processedOrder.order.orderEntryList.filter(f => f.services.length > 0) ?? [];
      let invoice = this.processedOrder.invoices.filter(f => f.deliveryInvoiceLines.some(s => productOnInvoice.length > 0 && s.orderEntryCode == productOnInvoice[0].code));

      this.ip800File = { code: 'new', customerCode: this.processedOrder.order.code, print: true };
      const sendEmailDisabledBranches = ((await this.paramsService.readParam("send-to-email-disabled-branches").toPromise()).response?.value ?? "").split(",");

      if (sendEmailDisabledBranches.includes(this.configService.readSelectedBranchAndSalesOrg().branch.code)) {
        this.checklist = (invoice ?? []).map(m => { return { code: m.code, salesOrgCode: m.salesOrg, print: true, checklistCode: m.fullNumber ?? "" } });
      }
      else {
        this.checklist = this.processedOrder.orderCheckLists.filter(f => f.status == OrderStatus.FINAL && f.isForEquipment).map(m => {
          return { code: m.invoiceCode, salesOrgCode: m.salesOrgCode, print: true, checklistCode: m.code }
        });
      }
      if (invoice && invoice.length > 0) {
        this.thirdPartyAuthoriztion.code = invoice[0].code;
        this.registrationRefusal.code = invoice[0].code;
        this.insuranceRejection.code = invoice[0].code;
      }
      this.circulationPermits = this.processedOrder.circulationPermitRequests.map(m => { return { code: m.code, print: true } });
      const branchesToShow = (await this.paramsService.readParam("branches-show-warranty-ummm").toPromise()).response?.value ?? "";
      const enableWarrantyUMParam = (await this.paramsService.readParam("enable-show-warranty-ummm").toPromise()).response?.value ?? "";
      const enableWarrantyUM = enableWarrantyUMParam.toLowerCase() == "si" || enableWarrantyUMParam.toLowerCase() == "true";
      if (this.processedOrder.order.salesOrgCode == "1600" || (enableWarrantyUM && (branchesToShow.includes(this.processedOrder.order.branchCode) || !branchesToShow))) {
        this.warrantyCertificate = this.processedOrder.invoices.filter(f => f.deliveryInvoiceLines.some(x => x.serialProfile)).map(x => {
          return {
            invoiceCode: x.code,
            invoiceNumber: x.fullNumber || "",
            print: true
          };
        });
      }
    }
  }

  private loadCreditDocuments() {
    if (this.processedOrder.order.condition == 'credito' && !this.processedOrder.order.isThirtyDays && this.processedOrder.order.status == OrderStatus.FINAL && (!this.processedOrder.order.digitalSignature || this.processedOrder.order.processingStatusDigitalSignature == DigitalSignatureRequestStatusInOrder.REJECTED)) {
      this.paymentPlan = this.processedOrder.loans.map(loan => {
        return { code: loan.contractNumber, print: true };
      });
      if (this.processedOrder.order.salesOrgCode != "1400")
        this.loan = this.processedOrder.loans.map(loan => {
          return { code: loan.contractNumber, print: true };
        });

      this.promissoryNotes = this.processedOrder.loans.map(loan => {
        return { code: loan.contractNumber, print: true };
      });

      if (CustomerType.EMPLOYEE == this.customer.customerType) {
        this.refinancing = this.processedOrder.loans.map(l => ({ code: l.contractNumber, print: true }))
      }
    }
  }

  private loadReceipts() {
    this.receipts = this.processedOrder.receipts.filter(f => !f.debitNote).map(receipt => {
      return { code: receipt.code, print: true };
    });

    this.debitNote = this.processedOrder.receipts.filter(f => f.debitNote).map(receipt => {
      return { code: receipt.code, print: true };
    });
  }

  private loadInvoiceDocuments() {
    if (this.processedOrder.order.orderType == OrderType.REPAIRSHOP) {
      this.innerLoadRepairshopInvoices();
    }
    else if (this.processedOrder.order.orderType != OrderType.RETURN) {
      this.innerLoadInvoiceDocuments();
    }
  }

  private innerLoadRepairshopInvoices() {
    const total = CalculationUtils.round(this.processedOrder.invoices.reduce((a, b) => a + b.totals.netTotal, 0) - this.processedOrder.payments.reduce((a, b) => a + b.amount, 0), 2);
    if (this.processedOrder.order.paymentCondition == "Z003" || (total <= 0 && this.processedOrder.order.paymentCondition != "Z003")) {
      this.invoices = this.processedOrder.invoices.flatMap(invoice => {
        return { code: invoice.code, fullNumber: invoice.fullNumber, print: true, printType: PrintType.ORIGINAL };
      }).concat(this.processedOrder.invoices.map(invoice => {
        return { code: invoice.code, fullNumber: invoice.fullNumber, print: true, printType: PrintType.COPY };
      }));
      this.invoiceRequests = this.processedOrder.invoices.map(invoice => {
        return { code: invoice.code, fullNumber: invoice.fullNumber, print: false };
      });
    }
  }

  private innerLoadInvoiceDocuments() {
    if (!this.isFranchisedInvoices) {
      this.invoices = this.processedOrder.invoices.flatMap(invoice => {
        return { code: invoice.code, fullNumber: invoice.fullNumber, print: true, printType: PrintType.ORIGINAL };
      });
    }

    if (this.canShowDigitalSignatureDocs && this.isDigitalSignatureDone && !this.isDigitalSignatureRejected ) {
      this.originalInvoices = this.processedOrder.invoices.map(invoice => {
        return { code: invoice.code, fullNumber: invoice.fullNumber, print: false, printType: PrintType.ORIGINAL };
      });
    }

    if (!this.canShowDigitalSignatureDocs || this.isDigitalSignatureRejected || this.isFranchisedInvoices) {
      // adding one invoice record for copies
      this.invoices = [...this.invoices, ...this.processedOrder.invoices.map(invoice => {
        return { code: invoice.code, fullNumber: invoice.fullNumber, print: true, printType: PrintType.COPY };
      })];
    }

    this.invoiceRequests = this.processedOrder.invoices.map(invoice => {
      return { code: invoice.code, fullNumber: invoice.fullNumber, print: false };
    });
  }

  private loadReturnDocuments() {
    if (this.processedOrder.order.orderType == OrderType.RETURN) {

      if (this.processedOrder.order.invoiceNumber || this.processedOrder.order.invoiceCode) {
        this.creditNotes = this.processedOrder.invoices.map(invoice => {
          return { code: invoice.code, fullNumber: invoice.fullNumber, salesOrg: invoice.salesOrg, print: true };
        });
      }
      else if (this.processedOrder.order.receiptCode) {
        this.receiptRollbacks = this.processedOrder.invoices.map(invoice => {
          return { code: invoice.code, fullNumber: invoice.fullNumber, salesOrg: invoice.salesOrg, branchCode: invoice.branchCode, receiptCode: this.processedOrder.order.receiptCode, sellerCode: this.authService.readProfileInStorage().username, print: true };
        });
      }

      this.loanCancellations = this.processedOrder.contractCancellations.map(m => { return { code: m.code, contractNumber: m.contractNo, print: false }; })
    }
  }

  private loadQuotationDocuments() {
    if (this.processedOrder.order.orderType == OrderType.QUOTATION) {
      this.quotations = this.processedOrder.loans.map(m => {

        return { loanCode: m.code, print: false };
      });

      if (this.quotations.length == 0) {
        this.quotations.push({ loanCode: undefined, print: false });
      }
    }
  }


  private innerGenerateDomainInfo(m: Invoice) {
    switch (this.customer.mainPersonalInfo?.personality) {
      case Personality.PERSON:
        this.domainTraditionFiles.push({
          code: m.code, invoiceNumber: `${m.fullNumber || ""} Persona a Persona`, print: true, type: DomainTraditionReportType.PERSON_TO_PERSON
        });
        this.domainTraditionFiles.push({
          code: m.code, invoiceNumber: `${m.fullNumber || ""} Persona a Jurídico`, print: true, type: DomainTraditionReportType.PERSON_TO_JURIDIC
        });
        this.domainTraditionFiles.push({
          code: m.code, invoiceNumber: `${m.fullNumber || ""} Jurídico a Jurídico`, print: false, type: DomainTraditionReportType.JURIDIC_TO_JURIDIC
        });
        this.domainTraditionFiles.push({
          code: m.code, invoiceNumber: `${m.fullNumber || ""} Jurídico a Persona`, print: false, type: DomainTraditionReportType.JURIDIC_TO_PERSON
        });
        break;
      case Personality.LEGAL_ENTITY:
        this.domainTraditionFiles.push({
          code: m.code, invoiceNumber: `${m.fullNumber || ""} Jurídico a Jurídico`, print: true, type: DomainTraditionReportType.JURIDIC_TO_JURIDIC
        });
        this.domainTraditionFiles.push({
          code: m.code, invoiceNumber: `${m.fullNumber || ""} Jurídico a Persona`, print: true, type: DomainTraditionReportType.JURIDIC_TO_PERSON
        });
        this.domainTraditionFiles.push({
          code: m.code, invoiceNumber: `${m.fullNumber || ""} Persona a Persona`, print: false, type: DomainTraditionReportType.PERSON_TO_PERSON
        });
        this.domainTraditionFiles.push({
          code: m.code, invoiceNumber: `${m.fullNumber || ""} Persona a Jurídico`, print: false, type: DomainTraditionReportType.PERSON_TO_JURIDIC
        });
        break;
      default:
        break;
    }
  }

  private loadDomainTraditionDocuments() {
    if (this.processedOrder.order.salesOrgCode != "1400") {
      this.processedOrder.invoices.filter(m => m.deliveryInvoiceLines.some(s => s.serialProfile)).forEach(m => {
        this.innerGenerateDomainInfo(m)
      });
    }
  }

  get isDigitalSignatureRejected(): boolean {
    return this.digitalSignature && this.digitalSignature.processingStatus === DigitalSignatureRequestStatus.REJECTED;
  }

  get canShowDigitalSignatureDocs(): boolean {
    return this.processedOrder.order.digitalSignature || this.loanObj.canSign;
  }


  get isDigitalSignatureDone(): boolean {
    return this.digitalSignature && this.digitalSignature.processingStatus === DigitalSignatureRequestStatus.DONE;
  }

  get validationShowManualDocuments(): boolean {
    return !this.isOnlyCreditsDocuments || ((!this.canShowDigitalSignatureDocs || this.isDigitalSignatureRejected) && !this.processedOrder.order.isThirtyDays);
  }

  getDigitalSignatureDocName(docType: string): string {
    switch (docType) {
      case DigitalSignatureDocumentType.PROMISSORY_NOTE:
        return 'Pagaré';
      case DigitalSignatureDocumentType.INVOICE:
        return 'Factura';
      case DigitalSignatureDocumentType.LOAN:
        return 'Contrato';
      case DigitalSignatureDocumentType.DOMINANCE_TRADITION:
        return 'Tradición de dominio';
      case DigitalSignatureDocumentType.DEBIT_NOTE:
        return 'Nota de cargo';
      case DigitalSignatureDocumentType.LOAN_APPENDIX:
        return 'Anexo contrato';
      case DigitalSignatureDocumentType.PAYMENT_PLAN:
        return 'Plan de pagos';
      case DigitalSignatureDocumentType.REFINANCING:
        return 'Refinanciamiento';
      default:
        return 'Desconocido'
    }
  }

  cancel() {
    this.bsModalRef.hide();
  }

  async print() {

    let quotationReports = await Promise.all(this.quotations.filter(f => f.print).map(async quotation => {
      let blob = await this.reportService.quotationPDF(this.processedOrder.order.code, this.processedOrder.order.salesOrgCode, quotation.loanCode).toPromise()
      return blob;
    }));

    let invoiceReports: Blob[] = [];
    let invoicesCopy: Blob[] = [];
    let promissoryNotesReports: Blob[] = [];
    let paymentPlanReports: Blob[] = [];
    let loanReports: Blob[] = [];
    let reports = new Array<Blob>();
    let debitNoteReports: Blob[] = [];
    let settlementReport: Array<Blob> = [];
    let advanceReports: Array<Blob> = [];
    let reimbursementReport: Blob = new Blob();
    let creditReferenceReport: Blob = new Blob();
    let orderChecklistReports: Blob[] = [];
    let originalInvoiceReports: Blob[] = [];
    let refinancingReports: Blob[] = [];

    if (!this.canShowDigitalSignatureDocs || this.isDigitalSignatureRejected) {
      invoiceReports = await Promise.all(this.invoices.filter(s => s.print && s.printType === PrintType.ORIGINAL).map(async invoice => {
        let blob = (await this.reportService.invoicePdf(invoice.code, this.processedOrder.order.salesOrgCode).toPromise());
        return blob;
      }));

      promissoryNotesReports = await Promise.all(this.promissoryNotes.filter(s => s.print).map(async m => {
        // TODO: Pendiente revisar porque no se muestra el contrato para reimpresion desde detalle de contrato
        let blob = (await this.reportService.promisoryNotePdf(m.code, this.processedOrder.order.salesOrgCode || this.loanObj.salesOrg).toPromise())
        return blob;
      }));

      paymentPlanReports = await Promise.all(this.paymentPlan.filter(s => s.print).map(async m => {
        let blob = new Blob();
        if (this.loanObj.parameters.cashLoan) {
          blob = (await this.reportService.paymentPlanPdf(m.code, this.loanObj.salesOrg).toPromise())
        }
        else {
          blob = (await this.reportService.paymentPlanFinancedPdf(m.code, this.processedOrder.order.salesOrgCode || this.loanObj.salesOrg).toPromise())
        }
        return blob;
      }));


      loanReports = await Promise.all(this.loan.filter(s => s.print).map(async m => {
        // TODO: Pendiente revisar porque no se muestra el contrato para reimpresion desde detalle de contrato
        let blob = (await this.reportService.loanPdf(m.code, this.processedOrder.order.salesOrgCode || this.loanObj.salesOrg).toPromise())
        return blob;
      }));

      debitNoteReports = await Promise.all(this.debitNote.filter(s => s.print).map(async debitNote => {
        let blob = (await this.reportService.debitNotePdf(debitNote.code, this.processedOrder.order.salesOrgCode).toPromise());
        return blob;
      }));

      refinancingReports = await Promise.all(this.refinancing.filter(s => s.print).map(async refinan => {
        let blob = (await this.reportService.refinancingReport(refinan.code).toPromise())
        return blob;
      }));
    }

    invoicesCopy = await Promise.all(this.invoices.filter(s => s.print && s.printType === PrintType.COPY).map(async invoice => {
      let blob = (await this.reportService.invoiceCopyPdf(invoice.code, this.processedOrder.order.salesOrgCode).toPromise());
      return blob;
    }));

    await Promise.all(this.domainTraditionFiles.map(async item => {
      if (item.print) {
        reports.push((await this.reportService.domainTraditionPdf(item.code, this.processedOrder.order.salesOrgCode, item.type).toPromise()));
      }
    }));

    let receiptReports = await Promise.all(this.receipts.filter(s => s.print).map(async receipt => {
      let blob = (await this.reportService.receiptPdf(receipt.code).toPromise());
      return blob;
    }));

    orderChecklistReports = await Promise.all(this.checklist.filter(f => f.print).map(async checklist => {
      let blob = (await this.reportService.checklistPdf(checklist.code, checklist.salesOrgCode).toPromise());
      return blob;
    }))

    if (this.productDelivery.print) {
      orderChecklistReports.push(await this.reportService.productDeliveryPdf(this.orderChecklist.code).toPromise());
    }

    if (this.productVerification.print) {
      orderChecklistReports.push(await this.reportService.productVerificationPdf(this.orderChecklist.code).toPromise());
    }

    if (this.releaseOfResponsibility.print) {
      orderChecklistReports.push(await this.reportService.releaseOfResponsibilityReportPdf(this.orderChecklist.code).toPromise());
    }

    if (this.purchaseOrder.print) {
      reports.push(await this.reportService.purchaseOrderPdf(this.purchaseOrder.code).toPromise());
    }


    let warrantyReports = await Promise.all(this.warrantyCertificate.filter(s => s.print).map(async item => {
      let blob = (await this.reportService.warrantyCertificate(item.invoiceCode, this.processedOrder.order.salesOrgCode).toPromise());
      return blob;
    }));

    let circulationPermitReports = await Promise.all(this.circulationPermits.filter(s => s.print).map(async permit => {
      let blob = (await this.reportService.circulationPermit(permit.code, this.processedOrder.order.salesOrgCode).toPromise());
      return blob;
    }))

    if (this.thirdPartyAuthoriztion.print) {
      reports.push(await this.reportService.thirdPartyAuthorizationPdf(this.thirdPartyAuthoriztion.code, this.thirdPartyForm.identity, this.thirdPartyForm.name, this.processedOrder.order.salesOrgCode).toPromise());
    }

    if (this.registrationRefusal.print) {
      reports.push(await this.reportService.registrationRefusalPdf(this.registrationRefusal.code, this.registrationRefusal.location, this.processedOrder.order.salesOrgCode).toPromise());
    }

    if (this.insuranceRejection.print) {
      const response = (await this.insuranceRejectionService.createInsuranceRejection(this.insuranceRejection.code, this.insuranceRejection.location).toPromise()).response;
      reports.push(await this.reportService.insuranceRejection(response.code, this.processedOrder.order.salesOrgCode).toPromise());
    }

    let attachedReports = new Array<Blob>();

    if (this.ip800File.print) {
      if (this.ip800File.code == 'new') {
        const customerInfo = new CustomerTableModel();
        customerInfo.code = this.customer.code;
        customerInfo.fullName = this.customer.fullName;
        customerInfo.customerType = this.customer.customerType;
        customerInfo.fiscalId = this.customer.mainPersonalInfo.fiscalId;
        customerInfo.personality = this.customer.mainPersonalInfo.personality;
        const ip800result = await this.ip800ModalService.showAsync(customerInfo);
        attachedReports.push(ip800result);
      }
      else {
        attachedReports.push(await this.reportService.ip800PDF(this.ip800File.code, this.processedOrder.order.salesOrgCode).toPromise());
      }
    }

    const extraWarrantyReports = await Promise.all(this.extraWarrantyCertificate.filter(s => s.print).map(async item => {
      return await this.reportService.extraWarrantyCertificate(item.invoiceCode, item.orderEntryListIndex != undefined ? item.orderEntryListIndex.toString() : "", this.processedOrder.order.salesOrgCode).toPromise();
    }));

    const creditNoteReports = await Promise.all(this.creditNotes.filter(s => s.print).map(async creditNote => {
      return await this.reportService.creditNotePdf(creditNote.code, creditNote.salesOrg).toPromise();
    }))

    const voucherReports = await Promise.all(this.vouchers.filter(f => f.print).map(async voucher => {
      return await this.reportService.voucherPdf(voucher.code).toPromise();
    }))

    const returnReceiptReports = await Promise.all(this.returnReceipts.filter(f => f.print).map(async returnReceipt => {
      return (await this.reportService.receiptPdf(returnReceipt.code).toPromise());
    }))
    const receiptRollbackReports = await Promise.all(this.receiptRollbacks.filter(s => s.print).map(async receipt => {
      return await this.reportService.rollbackReceiptPdf(receipt.code, receipt.receiptCode, receipt.salesOrg, receipt.branchCode, receipt.sellerCode).toPromise();
    }))

    const recollectionReceiptReport = await Promise.all(this.recollectionReceipts.filter(r => r.print).map(r => this.reportService.receiptPdf(r.code).toPromise()));
    const recollectionInvoicesOriginalReport = await Promise.all(this.recollectionInvoices.filter(i => i.print && i.printType === PrintType.ORIGINAL).map(i => this.reportService.invoicePdf(i.code, i.salesOrg).toPromise()));
    const recollectionInvoicesCopyReport = await Promise.all(this.recollectionInvoices.filter(i => i.print && i.printType === PrintType.COPY).map(i => this.reportService.invoiceCopyPdf(i.code, i.salesOrg).toPromise()));

    if (this.settlement.print) {
      if (this.customerStatus == "BLQ") {
        this.exceptionSolutionService.showAlertWithSolution(`Impresión de Documentos`, `No se puede imprimir el finiquito para este cliente ya que se encuentra bloqueado, contactarse con el área de créditos`, undefined, 'error');
      }
      else {
        const response = await this.loanService.settlementDateValidation(this.settlement.code).toPromise();
        if (response) {
          settlementReport = [await this.reportService.settlementPdf(this.loanObj.contractNumber, this.loanObj.salesOrg, "Cajero", this.loanObj.lastPaymentDate ?? new Date()).toPromise()];

          this.loanObj = (await this.loanService.updatePrintAmount(this.loanObj.contractNumber).toPromise()).response;
          const maxAmountInvoiceSettlement = ((await this.paramsService.readParam("max-amount-print-invoices-settlement").toPromise()).response?.value ?? "0");
          const invoices = await Promise.all(this.loanObj.invoices.filter(f => f.reprintAmount <= Number(maxAmountInvoiceSettlement)).map(r => {
            const invoice = this.processedOrder.invoices.find(f => f.fullNumber == r.invoiceCode);
            if (invoice) {
              return this.reportService.invoicePdf(invoice.code, this.loanObj.salesOrg).toPromise();
            }
            return new Blob();
          }));
          settlementReport.push(...invoices.filter(f => f.size > 0));
        }
      }
    }

    if (this.canShowDigitalSignatureDocs && this.isDigitalSignatureDone) { //
      for (const element of this.digitalSignature.documents.filter(x => x.print)) {
        const doc = element;
        if (doc.documentType == DigitalSignatureDocumentType.INVOICE) {
          this.isFranchisedInvoices ? await this.getDigitalInvoiceUanataca(doc, invoicesCopy, invoiceReports) : await this.getDigitalInvoiceDocusign(doc, invoicesCopy, invoiceReports);
        }


        if (doc.documentType == DigitalSignatureDocumentType.LOAN)
          loanReports.push(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());

        if (doc.documentType == DigitalSignatureDocumentType.PAYMENT_PLAN)
          paymentPlanReports.push(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());

        if (doc.documentType == DigitalSignatureDocumentType.PROMISSORY_NOTE)
          promissoryNotesReports.push(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());

        if (doc.documentType == DigitalSignatureDocumentType.DEBIT_NOTE)
          debitNoteReports.push(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());

        if (doc.documentType == DigitalSignatureDocumentType.LOAN_APPENDIX)
          debitNoteReports.push(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());

        if(doc.documentType == DigitalSignatureDocumentType.REFINANCING)
          refinancingReports.push(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());
      }

    }

    if (this.advanceDocument.print) {
      advanceReports.push(await this.reportService.itemReservationPdf(this.advanceDocument.receiptCode, this.advanceDocument.salesOrg).toPromise());
    }
    if (this.advanceReturnDocument.print) {
      advanceReports.push(await this.reportService.printItemLiquidation(this.advanceReturnDocument.code).toPromise());
    }

    if (this.reimbursementDocument.print) {
      reimbursementReport = await this.reportService.reimbursementPdf(this.reimbursementDocument.documentNumber, this.reimbursementDocument.operation, this.reimbursementDocument.salesOrg).toPromise();
    }
    const invoiceRequestReports = await Promise.all(this.invoiceRequests.filter(f => f.print).map(r => {
      return this.reportService.invoiceRequestCheckSalesOrg(r.code).toPromise();
    }))

    if (this.creditReference.print) {
      creditReferenceReport = await this.reportService.creditReferencePdf(this.creditReference.customerCode, this.creditReference.toWhom, this.creditReference.salesOrg).toPromise();
    }



    const loanCancellationReports = await Promise.all(this.loanCancellations.filter(f => f.print).map(r => {
      return this.reportService.contractCancellation(r.code).toPromise();
    }))

    for (const originalInvoice of this.originalInvoices.filter(oi => oi.print)) {
      originalInvoiceReports.push(await this.reportService.invoicePdf(originalInvoice.code, this.processedOrder.order.salesOrgCode).toPromise());
    }

    await this.print24hReports(invoiceReports, invoicesCopy, receiptReports, promissoryNotesReports, loanReports, paymentPlanReports, circulationPermitReports, orderChecklistReports, creditNoteReports, voucherReports, receiptRollbackReports, settlementReport, advanceReports, reimbursementReport, originalInvoiceReports,refinancingReports);

    await this.reportService.printReports(
      ...reports,
      // ...invoicesCopy,
      // ...receiptReports,
      ...debitNoteReports,
      ...attachedReports,
      ...warrantyReports,
      //...circulationPermitReports,
      //...paymentPlanReports,
      //...loanReports,
      ...quotationReports,
      ...extraWarrantyReports,
      ...returnReceiptReports,
      ...recollectionReceiptReport,
      ...recollectionInvoicesOriginalReport,
      ...recollectionInvoicesCopyReport,
      //...promissoryNotesReports,
      ...invoiceRequestReports,
      creditReferenceReport,
      ...loanCancellationReports
    );
  }

  private async getDigitalInvoiceDocusign(doc: DigitalSignatureDocument, invoicesCopy: Blob[], invoiceReports: Blob[]) {
    if (doc.printType === PrintType.COPY) {
      invoicesCopy.push(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());
    } else {
      invoiceReports.push(
        await this.invoices.filter(s => s.print && s.printType === PrintType.ORIGINAL && doc.fileName.includes(s.fullNumber || '')).map(async (invoice) => {
          let blob = (await this.reportService.invoiceCopyPdf(invoice.code, this.processedOrder.order.salesOrgCode).toPromise());
          return blob;
        })[0]
      );
    }
  }

  private async getDigitalInvoiceUanataca(doc: DigitalSignatureDocument, invoicesCopy: Blob[], invoiceReports: Blob[]) {
    if (doc.printType === PrintType.ORIGINAL) {
      invoicesCopy.push(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());
    } else {
      invoiceReports.push(
        await this.invoices.filter(s => s.print && s.printType === PrintType.COPY && doc.fileName.includes(s.fullNumber || '')).map(async (invoice) => {
          let blob = (await this.reportService.invoiceCopyPdf(invoice.code, this.processedOrder.order.salesOrgCode).toPromise());
          return blob;
        })[0]
      );
    }
  }

  private async printDigitalSignatureDocs(printAll: boolean) {
    for (const element of this.digitalSignature.documents) {
      const doc = element;
      if (printAll) {
        this.reportService.printReport(await this.reportService.digitalSignaturePrintPDF(this.getDigitalSignatureId(), doc.code).toPromise());
      }
    }
  }

  getDigitalSignatureId(): string {
    return this.digitalSignature.requestNumber == undefined ? this.digitalSignature.envelopeId : this.digitalSignature.requestNumber.toString();
  }
  get isFranchisedInvoices() {
    return this.digitalSignature.requestNumber != undefined;
  }
  validatePrintButton(): boolean {
    if (this.thirdPartyAuthoriztion.print) {
      if (this.thirdPartyForm.identity.length < 13 || this.thirdPartyForm.name.length == 0) {
        return true;
      }
    }
    if (this.registrationRefusal.print) {
      return this.registrationRefusal.location.length == 0 ? true : false;
    }
    return false;
  }

  async print24hReports(invoiceOriginal: Array<Blob>, invoicesCopy: Array<Blob>, receiptReports: Array<Blob>, promissoryNotesReports: Array<Blob>, loan: Array<Blob>, paymentPlanloan: Array<Blob>, circulationPermitReports: Array<Blob>, orderChecklistReports: Array<Blob>, creditNoteReports: Array<Blob>, voucherReports: Array<Blob>, receiptRollbackReports: Array<Blob>, settlementReport: Array<Blob>, advanceReports: Blob[], reimbursementReport: Blob, originalInvoicesReports: Array<Blob>,refinancingReports:Array<Blob>) {
    let today = new Date();
    let reports = new Array<Blob>();

    let privileges = Array<string>();
    this.setPrivilegesForReports(today, invoiceOriginal, invoicesCopy, privileges, reports, receiptReports, promissoryNotesReports, loan, paymentPlanloan, circulationPermitReports, orderChecklistReports, creditNoteReports, voucherReports, receiptRollbackReports, settlementReport, advanceReports, reimbursementReport, originalInvoicesReports,refinancingReports);

    await this.reportService.printReportsSupervisor(privileges,
      ...reports);


  }

  private setPrivilegesForReports(today: Date, invoiceOriginal: Blob[], invoicesCopy: Blob[], privileges: string[], reports: Blob[], receiptReports: Blob[], promissoryNotesReports: Blob[], loan: Array<Blob>, paymentPlanloan: Array<Blob>, circulationPermitReports: Array<Blob>, orderChecklistReports: Array<Blob>, creditNoteReports: Array<Blob>, voucherReports: Array<Blob>, receiptRollbackReports: Array<Blob>, settlementReport: Array<Blob>, advanceReports: Blob[], reimbursementReport: Blob, originalInvoicesReports: Array<Blob>,refinancingReports:Array<Blob>) {

    if (this.processedOrder.invoices.some(s => today.getTime() > DateUtils.getDateFromStringForReports(s.timeStamp).getTime()) && (invoiceOriginal.length > 0 || invoicesCopy.length > 0)) {
      privileges.push("reprintInvoiceWithOutPayment_After24H");
      reports.push(...invoiceOriginal, ...invoicesCopy);
    } else if (this.processedOrder.invoices.some(s => DateUtils.getDateFromStringForReports(s.timeStamp).getTime() >= today.getTime()) && (invoiceOriginal.length > 0 || invoicesCopy.length > 0)) {
      privileges.push("reprintInvoiceWithOutPayment_Before24H");
      reports.push(...invoiceOriginal, ...invoicesCopy);
    }


    if (this.processedOrder.invoices.some(s => today.getTime() > DateUtils.getDateFromStringForReports(s.timeStamp).getTime()) && creditNoteReports.length > 0) {
      privileges.push("reprintCreditNote_After24H");
      reports.push(...creditNoteReports);
    } else if (this.processedOrder.invoices.some(s => DateUtils.getDateFromStringForReports(s.timeStamp).getTime() >= today.getTime()) && creditNoteReports.length > 0) {
      privileges.push("reprintCreditNote_Before24H");
      reports.push(...creditNoteReports);
    }

    if (this.processedOrder.invoices.some(s => today.getTime() > DateUtils.getDateFromStringForReports(s.timeStamp).getTime()) && receiptRollbackReports.length > 0) {
      privileges.push("reprintCreditNote_After24H");
      reports.push(...receiptRollbackReports);
    } else if (this.processedOrder.invoices.some(s => DateUtils.getDateFromStringForReports(s.timeStamp).getTime() >= today.getTime()) && receiptRollbackReports.length > 0) {
      privileges.push("reprintCreditNote_Before24H");
      reports.push(...receiptRollbackReports);
    }

    if (this.processedOrder.receipts.some(s => today.getTime() > DateUtils.getDateFromStringForReports(s.timeStamp).getTime()) && receiptReports.length > 0) {
      privileges.push("reprintReceipt_After24H");
      reports.push(...receiptReports);
    } else if (this.processedOrder.receipts.some(s => DateUtils.getDateFromStringForReports(s.timeStamp).getTime() >= today.getTime()) && receiptReports.length > 0) {
      privileges.push("reprintReceipt_Before24H");
      reports.push(...receiptReports);
    }

    if (this.processedOrder.loans.some(s => today.getTime() > DateUtils.getDateFromStringForReports(s.creationDate).getTime())) {
      if (promissoryNotesReports.length > 0 || loan.length > 0 || paymentPlanloan.length > 0 || refinancingReports.length > 0)
        privileges.push("reprintDocumentsCredit_After24H");
      if (promissoryNotesReports.length > 0) {
        reports.push(...promissoryNotesReports)
      }
      if (loan.length > 0) {
        reports.push(...loan);
      }
      if (paymentPlanloan.length > 0) {
        reports.push(...paymentPlanloan);
      }
      if(refinancingReports.length > 0){
        reports.push(...refinancingReports);
      }
    }
    else if (this.processedOrder.loans.some(s => DateUtils.getDateFromStringForReports(s.creationDate).getTime() >= today.getTime())) {
      if (promissoryNotesReports.length > 0 || loan.length > 0 || paymentPlanloan.length > 0 || refinancingReports.length > 0)
        privileges.push("reprintDocumentsCredit_Before24H");
      if (promissoryNotesReports.length > 0) {
        reports.push(...promissoryNotesReports)
      }
      if (loan.length > 0) {
        reports.push(...loan);
      }
      if (paymentPlanloan.length > 0) {
        reports.push(...paymentPlanloan);
      }
      if(refinancingReports.length > 0){
        reports.push(...refinancingReports);
      }
    }

    if (this.processedOrder.order.orderCondition !== OrderConditions.CASH_BILLLING && (invoiceOriginal.length > 0 || originalInvoicesReports.length > 0)) {
      privileges.push("printOriginalCreditInvoice");
    }

    if (this.processedOrder.circulationPermitRequests.some(s => !s.timestamp || today.getTime() > DateUtils.getDateFromStringForReports(s.timestamp).getTime()) && circulationPermitReports.length > 0) {
      privileges.push("printCirculationPermit_After24H");
      reports.push(...circulationPermitReports);
    }

    if (this.processedOrder.circulationPermitRequests.some(s => s.timestamp && DateUtils.getDateFromStringForReports(s.timestamp).getTime() >= today.getTime()) && circulationPermitReports.length > 0) {
      privileges.push("printCirculationPermit_Before24H");
      reports.push(...circulationPermitReports);
    }

    if ((this.processedOrder.vouchers.some(s => today.getTime() > DateUtils.getDateFromStringForReports(s.createdOn).getTime()) && voucherReports.length > 0) || ((this.isForPrintContractReturnDocuments || this.isOnlyCreditsDocuments) && voucherReports.length > 0)) {
      privileges.push("printVoucher_After24H");
      reports.push(...voucherReports);
    } else if ((this.processedOrder.vouchers.some(s => DateUtils.getDateFromStringForReports(s.createdOn).getTime() >= today.getTime()) && voucherReports.length > 0) || ((this.isForPrintContractReturnDocuments || this.isOnlyCreditsDocuments) && voucherReports.length > 0)) {
      privileges.push("printVoucher_Before24H");
      reports.push(...voucherReports);
    }

    if (this.advance.code && today.getTime() <= DateUtils.getDateFromStringForReports(this.advance.timeStamp).getTime()) {
      privileges.push("printAdvance_Before24H");
      reports.push(...advanceReports);
    }
    else if (this.advance.code && today.getTime() > DateUtils.getDateFromStringForReports(this.advance.timeStamp).getTime()) {
      privileges.push("printAdvance_After24H")
      reports.push(...advanceReports);
    }

    if (this.reimbursement.code) {
      privileges.push("rePrintReimbursement");
      reports.push(reimbursementReport);
    }
    if (orderChecklistReports.length > 0 && DateUtils.getDateFromStringForReports(this.orderChecklist.endDate)) {
      const date = DateUtils.getDateFromStringForReports(this.orderChecklist.endDate);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);

      if (date.getTime() >= today.getTime()) {
        privileges.push("printOrderChecklistReports_Before24H");
      }
      else {
        privileges.push("printOrderChecklistReports_After24H")
      }
      reports.push(...orderChecklistReports);
    }

    if (this.settlement.code && this.settlement.print) {
      privileges.push("print-settlement-action");
      reports.push(...settlementReport);
    }

    if (this.processedOrder.invoices.some(s => today.getTime() > DateUtils.getDateFromStringForReports(s.timeStamp).getTime()) && (originalInvoicesReports.length > 0)) {
      privileges.push("reprintInvoiceWithOutPayment_After24H");
      reports.push(...originalInvoicesReports);
    } else if (this.processedOrder.invoices.some(s => DateUtils.getDateFromStringForReports(s.timeStamp).getTime() >= today.getTime()) && (originalInvoicesReports.length > 0)) {
      privileges.push("reprintInvoiceWithOutPayment_Before24H");
      reports.push(...originalInvoicesReports);
    }
  }

  selectAllDocuments(): void {
    this.quotations.forEach(c => c.print = true);
    this.invoices.forEach(invoice => invoice.print = true);
    this.loan.forEach(loan => loan.print = true);
    this.receipts.forEach(r => r.print = true);
    this.debitNote.forEach(d => d.print = true);
    this.paymentPlan.forEach(pp => pp.print = true);
    this.promissoryNotes.forEach(pn => pn.print = true);
    this.circulationPermits.forEach(c => c.print = true);
    this.domainTraditionFiles.forEach(dt => dt.print = true);
    this.warrantyCertificate.forEach(w => w.print = true);

    if (!(this.processedOrder.order.orderCondition != this.UNTIL_30_DAYS_FRANCHISED &&
      this.processedOrder.order.orderCondition != this.MORE_THAN_30_DAYS_FRANCHISED)) {
      this.purchaseOrder.print = true;
    }
    let services = this.processedOrder.order.orderEntryList
      .filter(f => f.productCode === "PAGO_MATRICULA" || f.productCode === "PAGO_PLACA")
      .map(m => m.code);

    if (services.length > 0 && this.processedOrder.order.status == OrderStatus.FINAL) {
      if (this.processedOrder.ip800Request?.code) {
        this.ip800File.print = true;
      }
    }
    this.creditNotes.forEach(w => w.print = true);
    this.vouchers.forEach(w => w.print = true);
    this.returnReceipts.forEach(w => w.print = true);
    this.checklist.forEach(f => f.print = true);
    if (this.isForOrderChecklist) {
      this.releaseOfResponsibility.print = true;
      this.productDelivery.print = true;
      this.productVerification.print = true;
    }
  }
}
